import { ratesLabels } from 'axl-config';
async function updateCalculatorConfig() {
  let payments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    creditType,
    interestRate,
    loanTerm,
    downPayment,
    downPaymentPercent,
    leaseTerm,
    leaseMileageRange,
    interactions: {
      hasUpdatedWallet = false,
      paymentEmphasis = false,
      hasOpenedWallet = false,
      hasRequestedTaxesFees = false
    } = {},
    tradeIn = {}
  } = payments;
  const isWalletEnabled = hasUpdatedWallet || paymentEmphasis || hasOpenedWallet;
  const {
    value: tradeInValue = 0,
    amountOwed = 0
  } = tradeIn;
  const {
    selectedCreditType,
    interestRate: selectedInterestRate,
    selectedLoanTerm,
    financeDownPayment,
    financeDownPaymentPercentage,
    selectedLeaseTerm,
    selectedLeaseMileage
  } = config?.selectedCriteria || {};
  if (isWalletEnabled) {
    return {
      ...config,
      ...(hasRequestedTaxesFees && {
        includeTaxesAndFees: hasRequestedTaxesFees
      }),
      selectedCriteria: {
        ...config.selectedCriteria,
        selectedLoanTerm: Number(loanTerm),
        selectedCreditType: ratesLabels[creditType]?.decodedValue,
        financeDownPayment: downPayment,
        financeDownPaymentPercentage: downPaymentPercent,
        interestRate: Object.keys(interestRate).length > 0 ? interestRate : {},
        selectedLeaseTerm: Number(leaseTerm),
        selectedLeaseMileage: Number(leaseMileageRange),
        tradeInValue,
        amountOwed
      }
    };
  }
  return {
    ...config,
    selectedCriteria: {
      ...config.selectedCriteria,
      selectedLoanTerm,
      selectedCreditType,
      financeDownPayment,
      financeDownPaymentPercentage,
      interestRate: Object.keys(selectedInterestRate).length > 0 ? selectedInterestRate : {},
      selectedLeaseTerm,
      selectedLeaseMileage,
      tradeInValue,
      amountOwed
    }
  };
}
export { updateCalculatorConfig as default };
